import React from "react";
import { Link } from "react-router-dom";

function Card({ item }) {
  return (
    <div className="shutter-card">
      <Link
        to={`/categories/${item?.slug || item?.slugPath}`}
        className="image img-style d-block"
      >
        <div className="img-layer">
          {/* <img src={cat.img} alt={cat.title} /> */}
          {item?.image && (
            <img src={item?.image} alt="categories" className="lazyload" />
          )}
        </div>
        <div className="shutter-panel panel-left"></div>
        <div className="shutter-panel panel-right"></div>
        <div className="content-layer">
          <div className="text-box">         
            <h3>Disease</h3>  
            {/* <p>{item.description}</p>      */}
            <div className="btn-wrapper">
              <Link to="/shop" className="shutter-btn">
             Acidity, Sugar BP(Heart), Joint Pain
              </Link>
            </div>
          </div>
        </div>


        <div className="border-trace"></div>
      </Link>
    </div>
  );
}

export default Card;
